import React from 'react'
import ChangeProductModal from './ChangeProductModal'
import {ReactComponent as ExchangeIcon} from '../../../assets/icons/exchange.svg'
import { useNavigate } from 'react-router-dom'

const ChangeProductButton = () => {
    const [isModalOpen, setIsModalOpen] = React.useState(false)
    const navigate = useNavigate()
    const _toggleModal = () => {
        setIsModalOpen(!isModalOpen)
    }

    const handleChangeProduct = () => {
        navigate('/')
    }

    return (
        <div className="ChangeProductButton">
            <button onClick={_toggleModal}><ExchangeIcon width={20}/> Change product</button>
            {isModalOpen && <ChangeProductModal isOpen={isModalOpen} toggleModal={_toggleModal}/>}
        </div>
    )
}

export default ChangeProductButton